module.exports = __webpack_public_path__ + "media/images/credits_logo-1deec378f3cb772bcb3f76d3423484d3.png";